import React from 'react';
import ReportsTabBar, {ReportType} from '../../components/reports/tab-bar/ReportsTabBar';
import PaymentStatisticTable from '../../components/reports/PaymentStatisticTable';
import {useSearchParams} from "react-router-dom";
import FewAvailableLessonsStatisticTable from "../../components/reports/FewAvailableLessonsStatisticTable";

const ReportsPage = () => {
    const [searchParams] = useSearchParams();

    return (
        <div className="columnContainer">
            <ReportsTabBar/>
            {searchParams.get('type') === ReportType.PAYMENTS && <PaymentStatisticTable/>}
            {searchParams.get('type') === ReportType.FEW_AVAILABLE_LESSONS && <FewAvailableLessonsStatisticTable/>}
        </div>
    );
};

export default ReportsPage;